import React from 'react';
import './App.css';
import Dashboard from './components/Dashboard';
import { ConfigProvider } from 'antd';
import zhTW from 'antd/lib/locale/zh_TW';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

const App: React.FC = () => {
  return (
    <ConfigProvider locale={zhTW}>
      <div className="App">
        <Router>
          <Routes>
            {/* 默認路由重定向到使用情況概覽 */}
            <Route path="/" element={<Navigate to="/usage/engagement-score" replace />} />
            
            {/* 用戶使用情況分析路由 */}
            <Route path="/usage/engagement-score" element={<Dashboard defaultMenu="engagement_score" />} />
            <Route path="/usage/resource-usage" element={<Dashboard defaultMenu="resource_usage" />} />
            <Route path="/usage/daily-search" element={<Dashboard defaultMenu="amount_daily" />} />
            
            {/* Analytics 關鍵詞分析路由 */}
            <Route path="/analytics/keywords/count" element={<Dashboard defaultMenu="keyword_count" />} />
            <Route path="/analytics/keywords/org-usage" element={<Dashboard defaultMenu="term_org_count" />} />
            <Route path="/analytics/keywords/search-records" element={<Dashboard defaultMenu="most_frequent_keyword" />} />
            <Route path="/analytics/keywords/repeat-analysis" element={<Dashboard defaultMenu="repeat_keyword" />} />

            {/* 保留既有網址相容性：直接轉址到正規路徑，避免與 Dashboard 的
                URL→menu 同步 effect 打架 (舊路徑不在 pathToMenuMap 會被重置回概覽) */}
            <Route path="/keywords/count" element={<Navigate to="/analytics/keywords/count" replace />} />
            <Route path="/keywords/org-usage" element={<Navigate to="/analytics/keywords/org-usage" replace />} />
            <Route path="/keywords/search-records" element={<Navigate to="/analytics/keywords/search-records" replace />} />
            <Route path="/keywords/repeat-analysis" element={<Navigate to="/analytics/keywords/repeat-analysis" replace />} />

            {/* API QSearch 客戶分析路由 */}
            <Route path="/api-qsearch/overview" element={<Dashboard defaultMenu="api_qsearch_overview" />} />
            <Route path="/api-qsearch/daily" element={<Dashboard defaultMenu="api_qsearch_daily" />} />
            <Route path="/api-qsearch/endpoints" element={<Dashboard defaultMenu="api_qsearch_endpoints" />} />
            <Route path="/api-qsearch/ads" element={<Dashboard defaultMenu="api_qsearch_ads" />} />
            {/* Channel / 關鍵詞已併入「每日呼叫趨勢」頁，舊網址轉址避免書籤失效 */}
            <Route path="/api-qsearch/channels" element={<Navigate to="/api-qsearch/daily" replace />} />
            <Route path="/api-qsearch/keywords" element={<Navigate to="/api-qsearch/daily" replace />} />

            {/* Trend 產品行為分析路由 */}
            <Route path="/trend-requests/hotposts-summary" element={<Dashboard defaultMenu="trend_hotposts_summary" />} />

            {/* Trend 功能深入分析路由 */}
            <Route path="/trend-requests/alert" element={<Dashboard defaultMenu="trend_alert" />} />
            <Route path="/trend-requests/export" element={<Dashboard defaultMenu="trend_export" />} />

            {/* 舊 trend 子頁轉址到熱門文章摘要 */}
            <Route path="/trend-requests/overview" element={<Navigate to="/trend-requests/hotposts-summary" replace />} />
            <Route path="/trend-requests/features" element={<Navigate to="/trend-requests/hotposts-summary" replace />} />
            <Route path="/trend-requests/activity" element={<Navigate to="/trend-requests/hotposts-summary" replace />} />
            
            {/* 404 重定向 */}
            <Route path="*" element={<Navigate to="/usage/engagement-score" replace />} />
          </Routes>
        </Router>
      </div>
    </ConfigProvider>
  );
};

export default App;
